import {Flex} from 'antd';
import React, {ReactNode} from 'react';

const IconWithLabel: React.FC<{icon: ReactNode; title: string}> = ({
  icon,
  title
}) => {
  return (
    <Flex vertical={true} className="toolIconWithLabel">
      {icon}
      <div className="tool-label">{title}</div>
    </Flex>
  );
};

export default IconWithLabel;
